<template>
  <div
    class="bb-settings-categories-project"
    @click="onSaveType"
  >
    <div
      v-for="(item, index) in typesList"
      class="bb-settings-categories-project-type"
      :key="item._id"
      @mouseenter="onMouseenter(index)"
      @mouseleave="onMouseleave"
      @keyup.enter="onKeyUp(item, index)"
    >
      <div class="bb-settings-categories-project-type__wrap">
        <div
          class="bb-settings-categories-project-type-block"
          @click="onOpenTab(item)"
        >
          <div
            class="bb-settings-categories-project-type-block__icon"
            :class="[item.isOpen && 'bb-settings-categories-project-type-block__icon_rotate']"
            v-html="ArrowIcon()"
          />
        </div>
        <div
          class="bb-settings-categories-project-type-name"
          @click.stop="onEdit(item, index)"
        >
          <template v-if="isEdit === index">
            <input
              @click.stop
              class="bb-settings-categories-project-type-name__input bb-input bb-input_border"
              :class="[isError && 'bb-input_error']"
              type="text"
              v-autofocus
              :value="item.name"
              @input="onChangeInput(item, $event)"
            >
            <transition name="bounce" appear>
              <span
                v-if="isError && isEdit === index"
                class="bb-settings-categories-project-type-name__error"
              >
                {{errorText}}
              </span>
            </transition>
          </template>
          <span v-else>
          {{item.name}}
        </span>
        </div>
        <ExpenseCategoriesListOfProjectTotalPercent
          :item="item"
        />
        <div>
          <button
            v-if="item.isNew"
            class="bb-settings-categories-project-type__button bb-button"
            :disabled="item.showSave ? isDisabledButtonAdd(item) : false"
            @click.stop="onCreateType(item, index)"
          >
            ADD
          </button>
          <button
            v-if="item.isNew ? false : item.showSave"
            class="bb-settings-categories-project-type__button bb-button"
            :disabled="isDisabledButtonAdd(item)"
            @click.stop="onSave(item)"
          >
            SAVE
          </button>
        </div>
        <template>
          <div
            v-if="item.isNew"
            class="bb-settings-categories-project-type__cancel"
            v-html="UnSaveIcon()"
            @click.stop="onCancelType(index)"
          />
          <transition name="fade-el">
            <template v-if="hoverRow === index">
              <img
                v-if="!item.isNew && !item.isAssignedProject"
                class="bb-settings-categories-project-type__delete"
                src="@/assets/images/icon-delete.png"
                @click.stop="onDelete(item, index)"
              />
              <div
                v-if="item.isAssignedProject"
                class="bb-settings-categories-project-type__info"
                v-html="ExclamationIcon()"
                @mouseenter="onMouseenterInfo($event)"
                @mouseleave="isShowInfo =  false"
              />
            </template>
          </transition>
        </template>
      </div>
      <ExpenseCategoriesListOfProjectStep
        v-if="item.isOpen"
        :item="item"
        ref="childComponent"
      />
    </div>
    <DoubleDelete
      v-if="openDoubleDelete"
      :title="currentItem.name"
      @close="openDoubleDelete = false"
      @delete="onDeleteType"
    />
    <transition name="bounce">
      <div
        v-if="isShowInfo"
        :style="popupStyle"
      >
        <BBPopupInfo
          customClass="type"
          text="Unfortunately, it cannot be deleted, since there is linked equipment in this type"
        />
      </div>
    </transition>
  </div>
</template>

<script>

import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import { ArrowIcon, UnSaveIcon, ExclamationIcon } from '@/constants/icon'
import TypeServiceProjectApi from '@/api/TypeServiceProject/api'
import ExpenseCategoriesListOfProjectStep
  // eslint-disable-next-line max-len
  from '@/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectStep/ExpenseCategoriesListOfProjectStep'
import ExpenseCategoriesListOfProjectTotalPercent from './ExpenseCategoriesListOfProjectTotalPercent'
import BBPopupInfo from '@/components/Main/BBPopupInfo/BBPopupInfo'
import createBodyTypeServiceProject from '@/mixin/createBodyTypeServiceProject'

export default {
  name: 'ExpenseCategoriesListOfProject',
  components: {
    ExpenseCategoriesListOfProjectTotalPercent,
    ExpenseCategoriesListOfProjectStep,
    DoubleDelete,
    BBPopupInfo
  },
  mixins: [createBodyTypeServiceProject],
  data: () => ({
    ArrowIcon,
    UnSaveIcon,
    ExclamationIcon,
    typesList: [],
    hoverRow: -1,
    isEdit: -1,
    currentItem: {},
    openDoubleDelete: false,
    errorText: 'mandatory field',
    isError: false,
    isShowInfo: false,
    popupStyle: {}
  }),
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    stepsNoRemove (steps) {
      return steps.filter((el) => !el.isRemove)
    },
    isDisabledButtonAdd (item) {
      // item.totalPercent !== 100 && item.steps.length
      // if (!item.showSave) return false
      const array = this.stepsNoRemove(item.steps)
      if (!array.length) return false
      return item.totalPercent !== 100 || item.isErrorMinStep
    },
    onMouseenterInfo ({ target }) {
      const pos = target.getBoundingClientRect()
      const { left, width, top, height } = pos
      this.popupStyle = {
        position: 'fixed',
        left: `${left + (width / 2) - 5}px`,
        top: `${top + height + 8}px`
      }
      this.isShowInfo = true
    },
    onKeyUp (item, index) {
      const { isNew } = item
      if (isNew) {
        this.onCreateType(item, index)
      } else {
        this.onSaveType()
      }
    },
    onMouseenter (index) {
      this.hoverRow = index
    },
    onMouseleave () {
      this.hoverRow = -1
    },
    onChangeInput (item, { target }) {
      this.isError = false
      item.name = target.value.trim()
      item.newName = target.value.trim()
    },
    isAdd () {
      const [newItem] = this.typesList
      const { isNew = false } = newItem
      if (isNew) return true
    },
    onEdit (item, index) {
      if (this.isError) {
        const { name } = this.currentItem
        this.typesList[this.isEdit].name = name
        this.isError = false
      }
      if (this.isAdd()) return
      this.isEdit = this.isEdit === index ? -1 : index
      this.currentItem = {...item}
    },
    isValid () {
      if (this.isAdd()) return true
      if (this.isEdit === -1) return true
      const { name } = this.currentItem
      const item = this.typesList[this.isEdit]
      const { newName } = item
      if (name === newName || newName === undefined) {
        this.isEdit = -1
        return true
      }
      if (newName) {
        const isFind = this.typesList.some((el) => el.name === newName && !el.newName)
        if (!isFind) return
        this.isError = true
        this.errorText = 'The category name has already been created'
        return true
      }

      if (!newName) {
        this.isError = true
        this.errorText = 'mandatory field'
        return true
      }
    },
    async onSaveType () {
      const item = this.typesList[this.isEdit]
      if (this.isValid()) return
      const { _id, user, index } = this.currentItem
      const body = {
        name: item.newName,
        user,
        index
      }
      this.isEdit = -1
      try {
        await TypeServiceProjectApi.updateTypeServiceProject(body, _id)
      } catch (err) {
        console.error(err)
      }
    },
    addNewType () {
      if (this.isEdit !== -1) {
        this.$emit('update:isDisabled', false)
        this.onSaveType()
        return
      }
      const newType = {
        name: '',
        steps: [],
        isNew: true,
        isOpen: true,
        totalPercent: 100
      }
      this.isEdit = 0
      this.typesList = [newType, ...this.typesList]
    },
    onOpenTab (item) {
      this.$set(item, 'isOpen', !item.isOpen)
    },
    async getTypeServiceProject () {
      try {
        const { data } = await TypeServiceProjectApi.getTypeServiceProject()
        this.typesList = data
      } catch (err) {
        console.error(err)
      }
    },
    isValidCreate (item) {
      const { name } = item
      if (!name.trim()) {
        this.isError = true
        this.errorText = 'mandatory field'
        return true
      }
      const isFind = this.typesList.some((el) => el.name === name && !el.isNew)
      if (isFind) {
        this.isError = true
        this.errorText = 'The category name has already been created'
        return true
      }
    },
    isErrorMinStep (item, steps) {
      if (steps.length === 1) this.$set(item, 'isErrorMinStep', true)
      return steps.length === 1
    },
    async onCreateType (item, index) {
      if (this.isValidCreate(item)) return
      const { addSteps } = this.createBodyStep(item)
      if (addSteps.length && this.isValidStep(addSteps)) return
      if (addSteps.length && this.isErrorMinStep(item, addSteps)) return
      const { name } = item
      this.isEdit = -1
      const { id } = this.userInfo
      const body = {
        type: {
          user: id,
          name
        },
        steps: addSteps || []
      }

      try {
        const { data } = await TypeServiceProjectApi.createTypeServiceProject(body)
        data.isOpen = true
        this.typesList.splice(index, 1, data)
        this.$emit('update:isDisabled', false)
      } catch (err) {
        console.error(err)
      }
    },
    onCancelType (index) {
      this.isEdit = -1
      this.$emit('update:isDisabled', false)
      this.typesList.splice(index, 1)
    },
    onDelete (item) {
      if (this.isEdit !== -1) {
        this.openDoubleDelete = false
        this.onSaveType()
        return
      }
      this.currentItem = item
      this.openDoubleDelete = true
    },
    async onDeleteType () {
      const { _id } = this.currentItem
      const index = this.typesList.findIndex((el) => el._id === _id)
      this.typesList.splice(index, 1)
      this.isEdit = -1
      this.openDoubleDelete = false
      try {
        await TypeServiceProjectApi.deleteTypeServiceProject(_id)
      } catch (err) {
        console.error(err)
      }
    },
    onSave (item) {
      const [component] = this.$refs.childComponent
      component.onSave(item)
    }
  },
  beforeMount () {
    this.getTypeServiceProject()
  },
  beforeDestroy () {
    this.$emit('update:isDisabled', false)
    this.isError = false
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-settings-categories-project {
    display: grid;
    grid-gap: 12px 0;
    overflow-y: scroll;
    max-height: calc(100vh - 212px);
    margin: 8px -10px 0 -10px;
    padding: 12px 10px 12px 10px;

    &::-webkit-scrollbar {
      width: 4px;
      height: 0;
      background-color: $color-white;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-denim;
    }
  }

  .bb-settings-categories-project-type {

    &__wrap {
      display: grid;
      grid-template-columns: 26px 1fr 110px 64px 24px;
      align-items: center;
      grid-gap: 0 12px;
      height: 64px;
      padding: 14px 14px 14px 14px;
      border-radius: 5px;
      box-shadow: 0 0 12px  rgba($color-black, 0.12);
    }

    &__text {
      font-size: 14px;
      line-height: 17px;
      text-align: end;
    }

    &__button {
      width: 64px;
      height: 36px;
    }

    &__cancel {
      cursor: pointer;
      opacity: 0.8;
      transition: 0.2s;
    }

    &__delete {
      width: 21px;
      height: 21px;
      cursor: pointer;
      transition: 0.15s;
    }

    &__info {
      display: flex;
      color: $color-silver-chalice;
      cursor: pointer;
      transition: 0.2s;
    }
  }

  .bb-settings-categories-project-type-block {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin: 0 0 0 -12px;
    cursor: pointer;

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 1px solid $color-denim;
      width: 16px;
      height: 16px;
      transition: 0.2s;
      transform: rotate(270deg);

      &_rotate {
        transform: rotate(360deg);
      }
    }
  }

  .bb-settings-categories-project-type-name {
    margin: 0 0 0 -10px;
    font-size: 14px;
    line-height: 19px;
    font-weight: 500;
    position: relative;

    &__input {
      height: 35px;
      width: 100%;
      padding: 8px 7px;
      font-weight: 500;
      transition: 0.3s;
    }

    &__error {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: $color-pomegranate;
      font-size: 11px;
      line-height: 13px;
      white-space: nowrap;
      pointer-events: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProject.vue